import { useMutation } from '@apollo/client'
import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { mapGraphQLErrors } from 'providers/graphql'
import { CommonProps } from '../../../types'
import { Schema } from '../../schema'
import { toDTO } from './api/mapper'
import { CONNECT_NATIVE_TO_GAM } from './api/mutation'
import { Data } from './api/types'
import { UseConnectNativeToGam } from './types'

export const useConnectNativeToGam = ({
  setIsDialogOpen,
}: Pick<CommonProps, 'setIsDialogOpen'>): UseConnectNativeToGam => {
  const { workspaceId } = useWorkspaceParam()
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection.setupPrebidStack.form',
  })
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})

  const [mutate, { loading }] = useMutation(CONNECT_NATIVE_TO_GAM, {
    onCompleted: ({ connectNativeToGam: { errors } }: Data): void => {
      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))
        enqueueSnackbar(t('notification.error'), { variant: 'error' })
      } else {
        enqueueSnackbar(t('notification.success'), { variant: 'success' })
      }

      setIsDialogOpen(false)
    },
    refetchQueries: ['getGoogleAdManagerSetupOrders'],
  })

  const connect = (data: Schema): void =>
    void mutate({
      variables: {
        input: {
          ...toDTO(data),
          workspaceId,
        },
      },
    })

  return { connect, errors, loading }
}
